import { render, staticRenderFns } from "./ReceiptPlanDetail.vue?vue&type=template&id=5dfcef24&scoped=true"
import script from "./ReceiptPlanDetail.vue?vue&type=script&lang=js"
export * from "./ReceiptPlanDetail.vue?vue&type=script&lang=js"
import style0 from "./ReceiptPlanDetail.vue?vue&type=style&index=0&id=5dfcef24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dfcef24",
  null
  
)

export default component.exports